import { useRef, useState, useEffect } from "react";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import StepByStep from "./StepByStep";
import { Dialog } from "primereact/dialog";
import FormCrearCliente from "./FormCrearCliente";
import { Toast } from "primereact/toast";
import { useGlobalContext } from "../Config";

const items = [
  {
    label: "Seleccione Cliente",
  },
  {
    label: "Seleccione Productos",
  },
  {
    label: "Añada Subproductos Y Servicios",
  },
  {
    label: "Defina Tarifas",
  },
];
const FormBusquedaCliente = ({
  criterioBusqueda,
  hanldeCriterioBusqueda,
  clienteLocal,
  rut,
  setRut,
  razonSocial,
  setRazonSocial,
  alias,
  setAlias,
  nombreFantasia,
  setNombreFantasia,
  dni,
  setDni,
  isValid,
  setIsValid,
  nombreRepresentante,
  setNombreRepresentante,
  onClientesFound
}) => {
  const [showCreateClientDialog, setShowCreateClientDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [clientes, setClientes] = useState("");
  const [clienteData, setClienteData] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const { baseUrl } = useGlobalContext();
  const toast = useRef();

  // Hook para detectar tamaño de pantalla
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const toggleFormVisibilityCliente = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowCreateClientDialog(true);
  };

  const handleDialogClose = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowCreateClientDialog(false);
  };

  const fetchData = async (url) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json;charset=UTF-8");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      credentials: "include", 
    };

    const response = await fetch(url, requestOptions);
    return response.json();
  };

  const handleClienteResponse = (data) => {
    if (Array.isArray(data.clientes)) {
      if (data.clientes.length === 0) {
        const confirmCreate = window.confirm("Cliente no encontrado. ¿Desea crearlo?");
        if (confirmCreate) {
          setShowCreateClientDialog(true);
          const clienteData = {
            rut: rut,
            razon_social: razonSocial,
            nombre_fantasia: nombreFantasia,
            alias: alias
          };
          setClienteData(clienteData);
        }
      } else {
        setClientes(data.clientes);
        if (onClientesFound) {
          onClientesFound(data.clientes);
        }
      }
    } else {
      console.error("Data.clientes no es array:", data.clientes);
    }
  };

  const searchCliente = async () => {
    try {
      if (!isValidFiltrosCliente()) {
        alert("Debe ingresar al menos un parámetro de búsqueda");
        return;
      }

      setLoading(true);
      setFiltersApplied(true);

      // Búsqueda secuencial por campos
      let data;
      
      // 1. Buscar por RUT
      if (rut) {
        const url = `${baseUrl}getClientesByFiltro?rut=${rut}`;
        data = await fetchData(url);
        if (data.clientes && data.clientes.length > 0) {
          handleClienteResponse(data);
          return;
        }
      }

      // 2. Buscar por Razón Social
      if (razonSocial) {
        const url = `${baseUrl}getClientesByFiltro?razonSocial=${razonSocial}`;
        data = await fetchData(url);
        if (data.clientes && data.clientes.length > 0) {
          handleClienteResponse(data);
          return;
        }
      }

      // 3. Buscar por Nombre Fantasía
      if (nombreFantasia) {
        const url = `${baseUrl}getClientesByFiltro?nombreFantasia=${nombreFantasia}`;
        data = await fetchData(url);
        if (data.clientes && data.clientes.length > 0) {
          handleClienteResponse(data);
          return;
        }
      }

      // 4. Buscar por Alias
      if (alias) {
        const url = `${baseUrl}getClientesByFiltro?alias=${alias}`;
        data = await fetchData(url);
        if (data.clientes && data.clientes.length > 0) {
          handleClienteResponse(data);
          return;
        }
      }

      // Si no se encontraron resultados en ninguna búsqueda
      handleClienteResponse({ clientes: [] });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const searchClienteByRepresentante = async () => {
    try {
      if (!validateRepresentanteFiltros()) {
        alert("Debe ingresar el nombre del representante");
        return;
      }

      setLoading(true);
      const url = buildRepresentanteSearchUrl();
      const data = await fetchData(url);
      processClienteResponse(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const isValidFiltrosCliente = () => {
    return checkCabeceraFiltros();
  };

  const validateRepresentanteFiltros = () => {
    return checkCabeceraFiltrosRepresentante();
  };

  const checkCabeceraFiltros = () => {
    return (
      (rut !== null && rut !== undefined && rut !== "") ||
      (razonSocial !== null && razonSocial !== undefined && razonSocial !== "") ||
      (nombreFantasia !== null && nombreFantasia !== undefined && nombreFantasia !== "") ||
      (alias !== null && alias !== undefined && alias !== "")
    );
  };

  const checkCabeceraFiltrosRepresentante = () => {
    return (nombreRepresentante !== undefined && nombreRepresentante !== "") || true;
  };

  const buildRepresentanteSearchUrl = () => {
    return `${baseUrl}getClientesByRepresentante?nombre=${nombreRepresentante}`;
  };

  const processClienteResponse = (data) => {
    if (Array.isArray(data.clientes)) {
      setClientes(data.clientes);
      setFiltersApplied(true);
      if (onClientesFound) {
        onClientesFound(data.clientes);
      }
    } else {
      console.error("Data.clientes no es array:", data.clientes);
    }
  };

  // --------- validaciones del rut ------------
  const cleanRut = (rut) => {
    return rut.replace(/^0+|[^0-9kK]+/g, "").toUpperCase();
  };
  const validateRut = (rut) => {
    if (!rut || typeof rut !== "string") return false;
    const cleanRutVal = cleanRut(rut);
    if (cleanRutVal.length < 2) return false;

    const body = cleanRutVal.slice(0, -1);
    const verifier = cleanRutVal.slice(-1);

    let sum = 0;
    let multiplier = 2;

    for (let i = body.length - 1; i >= 0; i--) {
      sum += multiplier * +body[i];
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const mod = 11 - (sum % 11);
    const expectedVerifier =
      mod === 11 ? "0" : mod === 10 ? "K" : mod.toString();

    return expectedVerifier === verifier;
  };
  const formatRut = (rut) => {
    const cleanRutVal = cleanRut(rut);
    let result =
      cleanRutVal.slice(-4, -1) +
      "-" +
      cleanRutVal.substr(cleanRutVal.length - 1);

    for (let i = 4; i < cleanRutVal.length; i += 3) {
      result = cleanRutVal.slice(-3 - i, -i) + "." + result;
    }

    return result;
  };
  const handleRutChange = (event) => {
    const inputRut = event.target.value;
    setRut(inputRut);

    const cleanRutVal = cleanRut(inputRut);
    setIsValid(validateRut(cleanRutVal));
  };
  const handleRutBlur = () => {
    if (isValid) {
      setRut(formatRut(rut));
    }
  };

  // --------- validaciones del form ------------
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault(); // Prevent form submission if needed
      searchCliente(); // Trigger the button's click event
    }
  };
  const handleKeyDown2 = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault(); // Prevent form submission if needed
      searchClienteByRepresentante(); // Trigger the button's click event
    }
  };

  return (
    <>
      
      {!isMobile && <StepByStep activeIndex={0} items={items} />}

        <h3 style={{ marginBottom: "5px" }}>Buscar Cliente</h3>

        <div className="p-fluid formgrid grid">
          <div className="field col-12 mt-2">
            <label style={{ marginRight: "10px", marginTop: "10px" }}>
              Búsqueda por Empresa
            </label>
            <InputSwitch
              checked={criterioBusqueda}
              onChange={hanldeCriterioBusqueda}
            />
            <label> Búsqueda por representante legal</label>
          </div>

          {!criterioBusqueda && (
            <form onKeyDown={handleKeyDown} className="p-fluid formgrid grid col-12">
              <div className="field col-12 md:col-6">
                {!clienteLocal && (
                  <>
                    <label htmlFor="rut"><i className="pi pi-id-card"></i> RUT Cliente</label>
                    <InputText
                      id="rut"
                      type="text"
                      value={rut}
                      onChange={handleRutChange}
                      onBlur={handleRutBlur}
                      maxLength={15}
                      style={{ borderColor: isValid || !rut ? "black" : "red" }}
                    />
                    {!isValid && rut && <p style={{ color: "red" }}>RUT Inválido</p>}
                  </>
                )}
                {clienteLocal && (
                  <>
                    <label htmlFor="dni"><i className="pi pi-id-card"></i> DNI o ID de Cliente</label>
                    <InputText
                      id="dni"
                      type="text"
                      value={dni}
                      maxLength={10}
                      onChange={(e) => setDni(e.target.value)}
                    />
                  </>
                )}
              </div>
              <div className="field col-12 md:col-6">
                <label htmlFor="razonSocial"><i className="pi pi-briefcase"></i> Razón Social (Nombre)</label>
                <InputText
                  id="razonSocial"
                  type="text"
                  value={razonSocial}
                  maxLength={50}
                  onChange={(e) => setRazonSocial(e.target.value.toUpperCase())}
                />
              </div>
              <div className="field col-12 md:col-6">
                <label htmlFor="nombreFan"><i className="pi pi-briefcase"></i> Nombre Fantasía</label>
                <InputText
                  id="nombreFan"
                  type="text"
                  value={nombreFantasia}
                  maxLength={50}
                  onChange={(e) =>
                    setNombreFantasia(e.target.value.toUpperCase())
                  }
                />
              </div>
              <div className="field col-12 md:col-6">
                <label htmlFor="alias"><i className="pi pi-tag"></i> Alias</label>
                <InputText
                  id="alias"
                  type="text"
                  value={alias}
                  maxLength={50}
                  onChange={(e) => setAlias(e.target.value.toUpperCase())}
                />
              </div>
              <div
                className="field col-12 md:col-12"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                  gap: "12px",
                  alignItems: "center",
                  width: "100%"
                }}
              >
                <Button
                  label="Crear Cliente"
                  icon="pi pi-plus"
                  onClick={toggleFormVisibilityCliente}
                  className={`p-button mr-2 mb-2 p-button-secondary ${!isMobile ? "p-button-rounded" : ""}`}
                  style={{ width: "100%" }}
                />
                <Button
                  type="button"
                  onClick={searchCliente}
                  label="Buscar Cliente"
                  icon="pi pi-search"
                  className={`p-button mr-2 mb-2 ${!isMobile ? "p-button-rounded" : ""}`}
                  style={{ width: "100%" }}
                />
              </div>
            </form>
          )}

          {criterioBusqueda && (
            <form onKeyDown={handleKeyDown2} className="field col-12 md:col-12">
              <div className="field col-12 md:col-12">
                <label htmlFor="nrepleg"><i className="pi pi-user"></i> Nombre Representante Legal</label>
                <InputText
                  id="nrepleg"
                  type="text"
                  value={nombreRepresentante}
                  maxLength={50}
                  onChange={(e) =>
                    setNombreRepresentante(e.target.value.toUpperCase())
                  }
                />
              </div>

              <div
                className="field col-12 md:col-12"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                  gap: "12px",
                  alignItems: "center",
                  width: "100%"
                }}
              >
                <Button
                  label="Crear Cliente"
                  icon="pi pi-plus"
                  onClick={toggleFormVisibilityCliente}
                  className={`p-button mr-2 mb-2 p-button-secondary ${!isMobile ? "p-button-rounded" : ""}`}
                  style={{ width: "100%" }}
                />
                <Button
                  type="button"
                  onClick={searchClienteByRepresentante}
                  label="Buscar Cliente"
                  icon="pi pi-search"
                  className={`p-button mr-2 mb-2 ${!isMobile ? "p-button-rounded" : ""}`}
                  style={{ width: "100%" }}
                />
              </div>
            </form>
          )}

          <Toast ref={toast} />
          <Dialog
            visible={showCreateClientDialog}
            onHide={handleDialogClose}
            style={{ width: "85vw" }}
            closable={true}
            modal
            dismissableMask={false}
            header={"Crear Cliente"}
          >
            <FormCrearCliente
              modoEdicion={false}
              clienteData={clienteData}
              onSuccess={() => {
                toast.current.show({
                  severity: "success",
                  summary: "Operación Exitosa",
                  detail: "El cliente ha sido guardado correctamente.",
                  life: 3000,
                });
                searchCliente();
                handleDialogClose();
              }}
              onError={(error) => {
                console.error("Error:", error);
                toast.current.show({
                  severity: "error",
                  summary: "Error",
                  detail: "Ha ocurrido un error al procesar la operación",
                  life: 3000,
                });
              }}
              onClose={handleDialogClose}
              fetchData={fetchData}
            />
          </Dialog>
        </div>

    </>
  );
};

export default FormBusquedaCliente;
